import { v4 as uuidv4 } from "uuid"

import {
  getKeyFromEmail,
  getFechaCreacionActualizacionObj,
  getAniomesActual,
  getFechaActualizacionObj,
} from "./commonUtils.js"
import { addItemEntityBase, deleteItemEntityBase, getItemEntityBase, updateItemEntityBase } from "./firebaseBaseDataUtils.js"
import { usuarios_area } from "./usuarios-commons.js"
// import { membresiasDisponiblesAF, membresiasInventarioAF } from "./accionferretera-commons.js"

export const membresias_entity = "membresias"
export const membresias_area = "user-priv-data-soloinsert"

// export const membresiasInventario = membresiasInventarioAF

// export const membresiasDisponibles = membresiasDisponiblesAF

export const buscarMembresiaBase = async (
  firebase,
  siteId,
  codigo,
  useruid
) => {
  try {
    return await getItemEntityBase(
      firebase,
      siteId,
      useruid + "/" + membresias_entity,
      usuarios_area,
      codigo,
      {
        includeKey: true,
      }
    )
  } catch (error) {
    console.error(error.message)
  }
}

export const crearMembresiaBase = async (
  firebase,
  siteId,
  useruid,
  negoId,
  dirEnvioId,
  values,
  membresiaInfo
) => {
  if (!useruid) throw new Error("No se ha proporcionado un useruid")

  if (!negoId) throw new Error("No se ha proporcionado un negoId")

  if (!dirEnvioId) throw new Error("No se ha proporcionado un dirEnvioId")

  const {
    aniomesfin: fin_aniomes,
    aniomesini: inicio_aniomes,
    email,
    membresia,
  } = values

  const id = uuidv4()

  const userInfo = {
    ["uid"]: useruid,
    ["email"]: email,
  }

  // const membresiaInfo = membresiasDisponibles[membresia]

  const newData = {
    id,
    email,

    ["user-uid"]: useruid,
    ["user-info"]: userInfo,
    ["negocio-id"]: negoId,
    ["direccion-envio-id"]: dirEnvioId,
    ...membresiaInfo,
    inicio_aniomes,
    fin_aniomes,
    ...getFechaCreacionActualizacionObj(),
  }

  console.debug(
    "🚀 ~ file: membresias-commons.js:113 ~ crearMembresiaBase ~ newData:",
    newData
  )

  const mem = await buscarMembresiaBase(
    firebase,
    siteId,
    membresiaInfo.codigo,
    useruid
  )
  if (mem) throw new Error("Ya existe una membresía con ese email")

  const new_mem = await addItemEntityBase(
    firebase,
    siteId,
    membresias_entity,
    membresias_area,
    id,
    newData,
    {
      includeKey: true,
    }
  )

  await addItemEntityBase(
    firebase,
    siteId,
    useruid + "/" + membresias_entity,
    usuarios_area,
    membresiaInfo.codigo,
    newData,
    {
      includeKey: true,
    }
  )

  return new_mem
}

export const esMembresiaVigente = memInfo =>
  memInfo?.fin_aniomes && memInfo.fin_aniomes >= getAniomesActual()







  export const seleccionarEliminarMembresiaBase = async (firebase, siteId, key) => {
    // const key = getKeyFromEmail(email)
  
    // const susPend = await buscarMembresiaBase(firebase, siteId, key)
    const mem = await getItemEntityBase(firebase, siteId, membresias_entity, membresias_area, key)
  
    if (!mem)
      throw new Error(`No existe una membresía con key [${key}]`)
  
    const updData = {
      DELETE: "DELETE",
      ...getFechaActualizacionObj(),
    }
  
    return await updateItemEntityBase(
      firebase,
      siteId,
      membresias_entity,
      membresias_area,
      key,
      updData,
      {
        includeKey: true,
      }
    )
  }
  export const cancelarEliminarMembresiaBase = async (firebase, siteId, key) => {
    // const key = getKeyFromEmail(email)
  
    // const susPend = await buscarSuscripcionBase(firebase, siteId, key)
    const mem = await getItemEntityBase(firebase, siteId, membresias_entity, membresias_area, key)
  
    if (!mem)
    throw new Error(`No existe una membresía con key [${key}]`)
  
    await deleteItemEntityBase(
      firebase,
      siteId,
      membresias_entity,
      membresias_area,
      key + "/DELETE"
    )
  }
  export const confirmarEliminarMembresiaBase = async (
    firebase,
    siteId,
    key
  ) => {
    // const key = getKeyFromEmail(email)

    // const susPend = await buscarSuscripcionBase(firebase, siteId, key)
    const mem = await getItemEntityBase(
      firebase,
      siteId,
      membresias_entity,
      membresias_area,
      key
    )

    if (!mem) throw new Error(`No existe una membresía con key [${key}]`)

    if (mem.DELETE != "DELETE")
      throw new Error(`No se puede eliminar la membresía [${key}]`)

    // if (susPend["suscripcion-key"]) {
    //   const sus = await getItemEntityBase(
    //     firebase,
    //     siteId,
    //     suscripciones_entity,
    //     suscripciones_area,
    //     susPend["suscripcion-key"],
    //     {
    //       includeKey: true,
    //     }
    //   )
    //   console.log(susPend["suscripcion-key"], { sus })

    //   //   const dbRef2 = admin
    //   //   .database()
    //   //   .ref(`/app/${siteId}/user-priv-data-read/suscripciones/${susInfoNew.key}`)
    //   // await dbRef2.set(susInfoNew)

    //   // const dbRefUsu = admin
    //   //   .database()
    //   //   .ref(`/app/${siteId}/usuarios/${useruid}/suscripciones/${susInfoNew.key}`)
    //   // await dbRefUsu.set(susInfoNew)
      console.debug("🚀 ~ file: membresias-commons.js:212 ~ susPend:", mem)
    const memUsu = await getItemEntityBase(
      firebase,
      siteId,
      mem["user-uid"] + "/" +membresias_entity,
      usuarios_area,
      mem.codigo,
      {
        includeKey: true,
      }
    )
    console.log({ memUsu })
    if (memUsu)
      await deleteItemEntityBase(
        firebase,
        siteId,
        mem["user-uid"] + "/" +membresias_entity,
        usuarios_area,
        mem.codigo
      )

    await deleteItemEntityBase(
      firebase,
      siteId,
      membresias_entity,
      membresias_area,
      mem.id
    )
    // }

    // await deleteItemEntityBase(firebase, siteId, susPendientes_entity, susPendientes_area, key)
  }